import { useState, useEffect, useCallback, useMemo, useRef } from 'react';
import { AllCommunityModule, ModuleRegistry, DateFilterModule, } from 'ag-grid-community';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { toast } from 'react-toastify';
import axiosInstance from '../../../lib/axios';
import { Box, Typography, CircularProgress, Tooltip, IconButton, Button } from '@mui/material';
import { usePermissions } from '../../../GlobalFunction/userPermissions';
import { ToastContainer } from 'react-toastify';
import { useSelector } from 'react-redux';
import { selectGlobalProperty } from '../../../redux/propertySlice';
import { useNavigate } from 'react-router-dom';
import AddIcon from '@mui/icons-material/Add';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import HomeIcon from '@mui/icons-material/Home';

ModuleRegistry.registerModules([AllCommunityModule, DateFilterModule,]);

const RefundTable = () => {
    const [rowData, setRowData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const UserId = sessionStorage?.getItem('UserId');
    const permissions = usePermissions("Payment Voucher");
    const { AddRec = "0" } = permissions || {};
    const gridRef = useRef();
    const navigate = useNavigate();
    const globalProperty = useSelector(selectGlobalProperty);

    const colDefs = useMemo(() => [
        { field: 'RowNum', headerName: 'Sr.No', width: 60 },
        { field: 'PytNo', headerName: 'VoucherNo', width: 100 },
        {
            field: 'PytDt', headerName: 'Date', width: 100, filter: 'agDateColumnFilter',
        },
        { field: 'MobileNo', headerName: 'Mobile', width: 100 },
        { field: 'PropName', headerName: 'Property', width: 190 },
        { field: 'ResidentName', headerName: 'Resident', width: 120 },
        { field: 'RcdAmt', headerName: 'Amount', width: 70 },
        { field: 'AgstBill', headerName: 'AgstBill', width: 70 },
        { field: 'OnacAmt', headerName: 'OnacAmt', width: 80 },
        { field: 'OnacBal', headerName: 'OnacBal', width: 70 },
        {
            field: 'Pyttype', headerName: 'PaymentType', width: 100,
            cellStyle: params => {
                if (params.value === 'Online') {
                    return { color: 'green', fontWeight: 'bold' };
                } else if (params.value === 'Cash') {
                    return { color: 'blue', fontWeight: 'bold' };
                } else if (params.value === 'RTGS/NEFT') {
                    return { color: 'purple', fontWeight: 'bold' };
                } else if (params.value === 'Bank') {
                    return { color: 'red', fontWeight: 'bold' };
                }
                return null;
            }
        },
        { field: 'ChequeNo', headerName: 'ChequeNo', width: 100 },
        { field: 'ChqInfvr', headerName: 'ChqInfvr', width: 100 },
        {
            field: 'ChqDt', headerName: 'ChqDt', width: 100, filter: 'agDateColumnFilter',
        },
        { field: 'Remark', headerName: 'Remark', width: 100 },
        {
            field: 'Status', headerName: 'Status', width: 80,
            valueFormatter: (params) => {
                return params.value === '1' ? 'Active' : 'Inactive';
            },
            cellStyle: (params) => ({
                color: params.value === 1 || params.value === '1' ? 'green' : 'red',
                fontWeight: 'bold',
            })
        },
    ], []);

    const defaultColDef = useMemo(() => ({
        sortable: true,
        filter: true,
        resizable: true,
        floatingFilter: true,
        width: 100,
        tooltipValueGetter: (params) => params.value ?? '',
    }), []);

    useEffect(() => {
        fetchRefundData()
    }, [globalProperty]);

    const fetchRefundData = async () => {
        setIsLoading(true);
        try {
            const response = await axiosInstance.post(`TrnPytvchr/GetTrnPytVchrDashBoard`,
                {
                    "PageNumber": 1,
                    "PageSize": 1,
                    "SearchText": ""
                }
            );
            if (response.data.Status === 0) {
                if (response.data.Data) {
                    const formattedData = response.data.Data.map(item => {
                        return Object.keys(item).reduce((acc, key) => {
                            if (key.endsWith("Dt") && item[key]) {
                                acc[key] = new Date(item[key]).toISOString().split('T')[0];
                            } else {
                                acc[key] = item[key];
                            }
                            return acc;
                        }, {});
                    });
                    setRowData(formattedData);
                } else {
                    setRowData([]);
                }
            }
        } catch (error) {
            console.error('Error fetching payment voucher data:', error);
        } finally {
            setIsLoading(false);
        }
    };

    const onGridReady = useCallback((params) => {

    }, []);

    const handleRowDoubleClick = useCallback((params) => {
       navigate(`/refund?mode=view&PytId=${params.data.PytId}`);
    }, [navigate]);

    const handlePermittedClick = () => {
        if (AddRec === "1") {
            navigate('/refund');
        }
    };

    const handleClearFilters = () => {
        gridRef.current?.api?.setFilterModel(null);
    };

    return (
        <Box
            sx={{
                width: '100%',
                height: '90vh',
                padding: '10px',
                backgroundColor: 'rgb(249, 249, 249)',
                position: 'relative'
            }}
        >
            <Box
                sx={{
                    backgroundColor: "#ffffff",
                    padding: { xs: "8px 16px", sm: "12px 16px" },
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    boxShadow: "0 2px 10px rgba(0, 0, 0, 0.05)",
                    borderRadius: "12px",
                    margin: "10px auto",
                    maxWidth: "95%",
                    flexDirection: { xs: "column", sm: "column", md: "row" },
                    gap: 2,
                }}
            >
                {/* Breadcrumbs with flexGrow to take full width */}
                <Breadcrumbs
                    aria-label="breadcrumb"
                    separator="›"
                    sx={{
                        fontSize: { xs: "14px", sm: "16px" },
                        display: "flex",
                        flexDirection: { xs: "column", sm: "column", md: "row" }
                    }}
                >
                    <Link
                        underline="hover"
                        color="#635bff"
                        sx={{ cursor: "pointer", fontWeight: "500", display: "flex", alignItems: "center" }}
                        onClick={() => navigate('/dashboard')}
                    >
                        <HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                        <Box component="span">Home</Box>
                    </Link>

                    <Link
                        underline="hover"
                        color="#635bff"
                        sx={{ cursor: "pointer", fontWeight: "500" }}
                        onClick={() => navigate('/enquiry/pre-registration')}
                    >
                        Booking(Pre-Registration)
                    </Link>

                    <Typography color="text.primary" sx={{ fontWeight: "500" }}>
                        Payment Voucher
                    </Typography>
                </Breadcrumbs>

                {/* Buttons container */}
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                        mt: { xs: 1, sm: 1, md: 0 },
                        flexShrink: 0,
                    }}
                >
                    <Tooltip title='Clear all applied filter' arrow>
                        <Button
                            variant="outlined"
                            onClick={handleClearFilters}
                            size="small"
                            sx={{
                                borderRadius: "50px",
                                textTransform: "none",
                                borderColor: "#635bff",
                                color: "#635bff",
                                "&:hover": {
                                    borderColor: "#524ccc",
                                    backgroundColor: "rgba(99, 91, 255, 0.04)",
                                }
                            }}
                        >
                            Clear Filters
                        </Button>
                    </Tooltip>

                    <Tooltip
                        title={AddRec !== "1" ? "You have no permission to add record" : "Add New Record"}
                        placement="top"
                        arrow
                    >
                        <span>
                            <Button
                                variant="contained"
                                onClick={handlePermittedClick}
                                size="small"
                                disabled={AddRec !== "1"}
                                sx={{
                                    background: AddRec === "1" ? "#635bff" : "rgba(0, 0, 0, 0.12)",
                                    color: AddRec === "1" ? "white" : "rgba(0, 0, 0, 0.26)",
                                    borderRadius: "50px",
                                    padding: "6px 15px",
                                    boxShadow: AddRec === "1" ? "0px 6px 15px rgba(0, 0, 0, 0.2)" : "none",
                                    "&:hover": {
                                        background: AddRec === "1" ? "#524ccc" : "rgba(0, 0, 0, 0.12)"
                                    }
                                }}
                            >
                                <AddIcon fontSize="small" sx={{ mr: 0.5 }} /> New
                            </Button>
                        </span>
                    </Tooltip>

                    <Tooltip title='Previous Page' arrow>
                        <Box sx={{
                            display: "flex", alignItems: "center", gap: 1,
                            justifyContent: "flex-start"
                        }}
                        >
                            <IconButton
                                onClick={() => navigate('/enquiry/pre-registration')}
                                sx={{
                                    backgroundColor: '#635bff',
                                    borderRadius: '50%',
                                    width: 35,
                                    height: 35,
                                    '&:hover': {
                                        backgroundColor: '#635bff',
                                    },
                                    boxShadow: 3,
                                }}
                            >
                                <ArrowBackIcon sx={{ color: 'white' }} />
                            </IconButton>
                        </Box>
                    </Tooltip>
                </Box>
            </Box>

            <Box className="table-grid ag-theme-alpine " sx={{ height: 'calc(97% - 56px)', width: '95%', margin: '0 auto', position: 'relative' }}>
                {isLoading ? (
                    <Box
                        sx={{
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                            zIndex: 10,
                            textAlign: 'center',
                        }}
                    >
                        <CircularProgress size="3rem" sx={{ color: '#635bff' }} />

                        <Typography sx={{ marginTop: 2, color: '#635bff', fontWeight: 'bold' }}>
                            Loading data...
                        </Typography>
                    </Box>
                ) : (
                    <AgGridReact
                        ref={gridRef}
                        rowData={rowData}
                        columnDefs={colDefs}
                        defaultColDef={defaultColDef}
                        pagination={true}
                        paginationPageSize={1000}
                        onRowDoubleClicked={handleRowDoubleClick}
                        paginationPageSizeSelector={[100, 500, 1000, 5000]}
                        onGridReady={onGridReady}
                        enableCellTextSelection={true}
                        rowHeight={25}
                        headerHeight={30}
                        floatingFiltersHeight={28}
                        overlayNoRowsTemplate={'<span class="ag-overlay-loading-center">No rows to show</span>'}
                        tooltipShowDelay={0}
                        getRowStyle={(params) => ({
                            backgroundColor: params.node.rowIndex % 2 === 0 ? '#f1f5fd' : '#ffffff'
                        })}
                    />
                )}
            </Box>
            <Box
                sx={{
                    position: 'absolute',
                    bottom: 16,
                    left: 70,
                    fontSize: '14px',
                    color: 'black',
                }}
            >
                Total Records: <b>{rowData.length}</b>
            </Box>
        </Box>
    );
};

export default RefundTable;